import BlogHero from './BlogHero';

export default BlogHero;
